import * as React from 'react'

export const SingleUser = (props) => {
    return (
        <Layout>
            Single user view
        </Layout>
    )
}
